var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-3" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("actions.actionDefinition.model.name")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.definition.name,
              expression: "definition.name"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.definition.name },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.definition, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("actions.actionDefinition.model.description")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.definition.description,
              expression: "definition.description"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.definition.description },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.definition, "description", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("actions.actionDefinition.model.type")))
          ]),
          _vm._v(" "),
          _c("vSelect", {
            attrs: {
              options: _vm.availableTypesForVSelect,
              label: "label",
              reduce: t => t.type,
              clearable: false
            },
            model: {
              value: _vm.definition.type,
              callback: function($$v) {
                _vm.$set(_vm.definition, "type", $$v)
              },
              expression: "definition.type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.definition.type === "duty.specific"
        ? _c("DefinitionEditorDutySpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === "survey_result.create_job"
        ? _c("DefinitionEditorSurveyResultSpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === "duty_survey.sms_alarm"
        ? _c("DefinitionEditorDutyAlarmSurveySpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === "survey_result.publish_mqtt_cell"
        ? _c("DefinitionEditorSurveyResultMqttSpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === "mqtt_subscriber_action"
        ? _c("DefinitionEditorMqttSubscriberSpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === "visitor_management_action"
        ? _c("DefinitionEditorMqttFromVisitorManagementSpecific", {
            attrs: {
              definition: _vm.definition,
              parsedJsonParameters: _vm.parsedJsonParameters
            },
            on: {
              changed: _vm.onParsedJsonChanged,
              canSaveChanged: _vm.onCanSaveChanged
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }